<template>
    <v-navigation-drawer
            floating
            permanent
            mini-variant

            class="hidden-md-and-down railNav mx-3 "
    >

        <v-list
                nav
                dense

                class="d-flex flex-column justify-center hidden-md-and-down"

                style="background: rgba(3,3,3,0.50); border-radius: 1.5rem"
        >


            <v-list-item link active-class="rail-blue-active" class="active">

                <v-tooltip
                        nudge-right="8"
                        right>
                    <template v-slot:activator="{ on, attrs }">

                        <router-link
                                to="/sendsms"
                                v-slot="{ href, navigate, isActive, isExactActive }">
                            <a target="_blank"
                               href="https://terminalads.com/contact/" style="width: 10rem; height: auto;" v-on="on"
                               v-bind="attrs">
                                <!--                <inline-svg :class="{'svg-white' : isActive}" src="media/svg/icons/Communication/Sending.svg" alt="" title="" v-on="on" v-bind="attrs"/>-->
                                <span class="fas fa-headset icon-xl" style="color: #F3F5F9; margin-right: 3px"></span>
                            </a>
                        </router-link>


                    </template>
                    <span style="white-space: nowrap" class="d-inline-block">تماس باما</span>
                </v-tooltip>


            </v-list-item>


            <v-list-item link active-class="rail-blue-active" class="active">

                <v-tooltip
                        nudge-right="8"
                        right>
                    <template v-slot:activator="{ on, attrs }">

                        <router-link
                                to="/sendsms"
                                v-slot="{ href, navigate, isActive, isExactActive }">
                            <a href="https://core_panel.terminalads.com/#/tickets" style="width: 10rem; height: auto;"
                               v-on="on" v-bind="attrs">
                                <!--                <inline-svg :class="{'svg-white' : isActive}" src="media/svg/icons/Communication/Sending.svg" alt="" title="" v-on="on" v-bind="attrs"/>-->
                                <!--                <span class="fas fa-forum-plus-outline icon-xl" style="color: #F3F5F9" v-on="on" v-bind="attrs"></span>-->
                                <v-icon style="color: #F3F5F9">mdi-forum</v-icon>
                            </a>
                        </router-link>


                    </template>
                    <span style="white-space: nowrap" class="d-inline-block">تیکت</span>
                </v-tooltip>


            </v-list-item>


            <v-list-item link active-class="rail-blue-active" class="active">

                <v-tooltip
                        nudge-right="8"
                        right>
                    <template v-slot:activator="{ on, attrs }">

                        <router-link
                                to="/sendsms"
                                v-slot="{ href, navigate, isActive, isExactActive }">
                            <a href="https://terminalads.com/%d9%81%d8%b1%d8%b5%d8%aa-%d9%87%d8%a7%db%8c-%d8%b4%d8%ba%d9%84%db%8c/"
                               target="_blank" style="width: 10rem; height: auto;" v-on="on" v-bind="attrs">
                                <!--                <inline-svg :class="{'svg-white' : isActive}" src="media/svg/icons/Communication/Sending.svg" alt="" title="" v-on="on" v-bind="attrs"/>-->
                                <span class="fa fa-handshake icon-xl" style="color: #F3F5F9" v-on="on"
                                      v-bind="attrs"></span>
                            </a>
                        </router-link>


                    </template>
                    <span style="white-space: nowrap" class="d-inline-block">فرصت های همکاری</span>
                </v-tooltip>


            </v-list-item>

            <v-list-item link active-class="rail-blue-active" class="active">

                <v-tooltip
                        nudge-right="8"
                        right>
                    <template v-slot:activator="{ on, attrs }">

                        <router-link
                                to="/sendsms"
                                v-slot="{ href, navigate, isActive, isExactActive }">
                            <a target="_blank" href="https://terminalads.com/about/" style="width: 10rem; height: auto;" v-on="on"
                               v-bind="attrs">
                                <!--                <inline-svg :class="{'svg-white' : isActive}" src="media/svg/icons/Communication/Sending.svg" alt="" title="" v-on="on" v-bind="attrs"/>-->
                                <!--                <span class="fa fa-handshake icon-xl" style="color: #F3F5F9" v-on="on" v-bind="attrs"></span>-->
                                <v-icon style="color: #F3F5F9">mdi-information</v-icon>
                            </a>
                        </router-link>


                    </template>
                    <span style="white-space: nowrap" class="d-inline-block">درباره ما</span>
                </v-tooltip>


            </v-list-item>


            <!--            <v-list-item link active-class="rail-blue-active" class="active" >-->

            <!--                <v-tooltip-->
            <!--                        nudge-right="8"-->
            <!--                        right>-->
            <!--                    <template v-slot:activator="{ on, attrs }">-->

            <!--                        <router-link-->
            <!--                                to="/sendsms"-->
            <!--                                v-slot="{ href, navigate, isActive, isExactActive }">-->
            <!--                            <a href="https://terminalads.com/%d9%81%d8%b1%d8%b5%d8%aa-%d9%87%d8%a7%db%8c-%d8%b4%d8%ba%d9%84%db%8c/" style="width: 10rem; height: auto;" v-on="on" v-bind="attrs">-->
            <!--                                &lt;!&ndash;                <inline-svg :class="{'svg-white' : isActive}" src="media/svg/icons/Communication/Sending.svg" alt="" title="" v-on="on" v-bind="attrs"/>&ndash;&gt;-->
            <!--                                <span class="fa fa-clipboard icon-xl" style="color: #F3F5F9; margin-right: 3px"></span>-->
            <!--                                &lt;!&ndash;                <v-icon style="color: #F3F5F9" v-on="on" v-bind="attrs">mdi-clipboard-edit</v-icon>&ndash;&gt;-->
            <!--                            </a>-->
            <!--                        </router-link>-->


            <!--                    </template>-->
            <!--                    <span style="white-space: nowrap" class="d-inline-block">استخدام</span>-->
            <!--                </v-tooltip>-->


            <!--            </v-list-item>-->


        </v-list>
    </v-navigation-drawer>
</template>

<script>
export default {
    name: "RailNavigation"
}
</script>

<style>
.railNav .v-navigation-drawer__content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    justify-items: center;
    max-height: 65vh;
}

.svg-white {
    filter: invert(96%) sepia(24%) saturate(2%) hue-rotate(316deg) brightness(111%) contrast(100%);
}
</style>

<style scoped>
.railNav {
    position: fixed;
    z-index: 1;
    top: 7rem;
    left: 0;
    background: transparent !important;

    transform: translateX(-50%);
    transition: margin-top 1s;
    margin-top: 30vh;

}

body[data-scrolltop="on"] .railNav {
    margin-top: 0;
}

@media only screen and (max-width: 956px) {
    .railNav {
        display: none;
    }
}
</style>